if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');
				if (this.variantIdInput) {
					this.variantIdInput.disabled = false;

					// Log variant input changes
					this.variantIdInput.addEventListener('change', (e) => {
						console.log('🔄 Variant input changed:', {
							value: e.target.value,
							form: this.form?.id,
						});
					});
				}
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButtons = this.querySelectorAll('[type="submit"]');
				this.submitButtonTexts = Array.from(this.submitButtons).map((button) =>
					button.querySelector('span'),
				);

				if (document.querySelector('cart-drawer')) {
					this.submitButtons.forEach((button) => button.setAttribute('aria-haspopup', 'dialog'));
				}

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (evt.submitter && evt.submitter.getAttribute('aria-disabled') === 'true') return;

				// Vérifier que l'ID de variante est valide avant l'envoi
				const variantInput = this.variantIdInput;
				const variantId = variantInput?.value;

				if (!variantId || variantId === '' || variantId === 'null') {
					console.error('❌ Product form: No valid variant ID found');

					// Attendre un peu pour laisser le temps aux événements de variant change de se propager
					setTimeout(() => {
						const retryVariantId = this.variantIdInput?.value;
						if (!retryVariantId || retryVariantId === '' || retryVariantId === 'null') {
							this.handleErrorMessage('Veuillez sélectionner une variante');
						} else {
							// Retry submission with valid variant ID
							this.handleErrorMessage();
							this.submitWithValidVariant();
						}
					}, 100);
					return;
				}

				this.handleErrorMessage();

				this.submitButtons.forEach((button) => {
					button.setAttribute('aria-disabled', true);
					button.classList.add('loading');
				});
				this.querySelector('.loading__spinner').classList.remove('hidden');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.section),
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							this.submitButtons.forEach((button) => {
								const soldOutMessage = button.querySelector('.sold-out-message');
								if (!soldOutMessage) return;
								button.setAttribute('aria-disabled', true);
								const buttonText = button.querySelector('span');
								if (buttonText) buttonText.classList.add('hidden');
								soldOutMessage.classList.remove('hidden');
							});
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response,
							}).then(() => {
								CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
							});
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										CartPerformance.measure('add:paint-updated-sections', () => {
											this.cart.renderContents(response);
										});
									});
								},
								{ once: true },
							);
							quickAddModal.hide(true);
						} else {
							CartPerformance.measure('add:paint-updated-sections', () => {
								this.cart.renderContents(response);
							});
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButtons.forEach((button) => {
							button.classList.remove('loading');
							if (!this.error) button.removeAttribute('aria-disabled');
						});
						if (this.cart && this.cart.classList.contains('is-empty'))
							this.cart.classList.remove('is-empty');
						this.querySelector('.loading__spinner').classList.add('hidden');

						CartPerformance.measureFromEvent('add:user-action', evt);
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector('.product-form__error-message');

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			toggleSubmitButton(disable = true, text) {
				console.log('toggleSubmitButton appelé. disable:', disable, 'text:', text);

				this.submitButtons.forEach((button, index) => {
					const buttonText = this.submitButtonTexts[index];

					if (disable) {
						button.setAttribute('disabled', 'disabled');
						if (text && buttonText) {
							buttonText.textContent = text;
						}
					} else {
						button.removeAttribute('disabled');
						if (buttonText) {
							buttonText.textContent = window.variantStrings.addToCart;
						}
					}
				});
			}

			get variantIdInput() {
				return (
					this.form.querySelector('[name=id]') || this.form.querySelector('[name="items[0][id]"]')
				);
			}
		},
	);
}
